import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Source } from '@/entities/models/Source';
import { SourceGroup } from '@/entities/models/SourceGroup';
import LoggerInfo from '@/views/components/logger/LoggerInfo.vue';
import LoggerChanges from '@/views/components/logger/LoggerChanges.vue';
import SetServiceModal from '@/views/components/logger/SetServiceModal.vue';
import EditServiceModal from '@/views/components/logger/EditServiceModal.vue';
import VueUtilities from '@/services/VueUtilities';
import SourceRepository from '@/services/repository/SourceRepository';
import CompanyLoggerRepository from '@/services/repository/CompanyLoggerRepository';
import SourceGroupRepository from '@/services/repository/SourceGroupRepository';
import EventTypeRepository from '@/services/repository/EventTypeRepository';
import EventType from '@/entities/EventType';
import EventDomain from '@/entities/enums/eventDomains';
import DateTimeManager from '@/services/DateTimeManager';
import UnsavedChangesDialog from '@/views/components/common/UnsavedChangesDialog.vue';
import { SourceChanges } from '@/entities/models/SourceChanges';
import { SourceService } from '@/entities/models/SourceService';
import TiersRepository from '@/services/repository/TiersRepository';
import LoggerRssiChart from '@/views/components/logger/LoggerRssiChart.vue';
import DiscardLoggerModal from '../components/logger/DiscardLoggerModal.vue';
import { CompanyLogger } from '@/entities/models/CompanyLogger';
import ChangeLoggerModal from '../components/logger/ChangeLoggerModal.vue';
import UserSettingsRepository from '@/services/repository/UserSettingsRepository';
import { CustomerPermissions } from '@/services/permissions/CustomerPermissions';
import ReadDataFromLoggerModal from '@/views/components/logger/ReadDataFromLoggerModal.vue';
import AppConfig from '@/configLoader';
import { Features } from '@/entities/tiers/Features';
var sourceRepository;
var sourceGroupRepository;
var eventTypeRepository;
var tiersRepository;
var userSettingsRepository;
var companyLoggerRepository;
let LoggerDetail = class LoggerDetail extends Vue {
    constructor() {
        super(...arguments);
        this.source = new Source();
        this.quantities = [];
        this.sourceGroups = new Array();
        this.availableCompanyLoggers = [];
        this.eventTypes = [];
        this.dateTimeManager = null;
        this.sourceChanges = [];
        this.annotateLogerStateChange = 'true';
        this.isUnsavedChangesModalActive = false;
        this.isServiceModalActive = false;
        this.isEditServiceModalActive = false;
        this.isDiscardLoggerModal = false;
        this.isChangeLoggerModalActive = false;
        this.modalIsReassigning = false;
        this.routeToNavigate = null;
        this.isLoading = true;
        this.isEditing = false;
        this.isLoadingSignal = false;
        this.currentTime = new Date();
        this.tier = null;
        this.rssiData = [];
        this.isReadDataModalActive = false;
        this.memoryReadLoggers = AppConfig.getConfig().attributes.memory_read_allowed_loggers;
    }
    get hasService() {
        return (this.source.activeService && !this.source.activeService.endTime) ||
            (this.source.activeService &&
                this.source.activeService.endTime &&
                this.source.activeService.endTime * 1000 > new Date().getTime())
            ? true
            : false;
    }
    get hasReadDataFeature() {
        return (AppConfig.getConfig().features.read_logger_data === true &&
            this.$userCan(CustomerPermissions.LOGGERS_ACTION_MEMORY_READ) &&
            this.$featuresManager.isAvailable(Features.READ_LOGGER_DATA));
    }
    get canReadData() {
        if (this.source?.logger?.isOnline === true &&
            this.memoryReadLoggers.find((x) => this.source?.logger?.serialNumber?.startsWith(x))) {
            return true;
        }
        else
            return false;
    }
    async created() {
        sourceRepository = new SourceRepository(this);
        sourceGroupRepository = new SourceGroupRepository(this);
        companyLoggerRepository = new CompanyLoggerRepository(this);
        eventTypeRepository = EventTypeRepository.getInstance(this);
        tiersRepository = new TiersRepository(this);
        userSettingsRepository = UserSettingsRepository.getInstance(this);
        this.dateTimeManager = await DateTimeManager.CreateManager(this);
        await this.loadData();
    }
    async loadData() {
        this.isLoading = true;
        let allPromises = [];
        allPromises.push(sourceGroupRepository.getSourceGroups(null, null, true));
        allPromises.push(sourceRepository.getSource(this.$route.params.locationId));
        allPromises.push(eventTypeRepository.getTypesFilteredByDomain(EventDomain.MEASURED, true));
        allPromises.push(eventTypeRepository.getSelectedUnits());
        allPromises.push(sourceRepository.getLoggerChanges(this.$route.params.locationId));
        allPromises.push(tiersRepository.getActiveTier());
        allPromises.push(companyLoggerRepository.getCompanyLoggers());
        allPromises.push(sourceRepository.getVisibleSources());
        allPromises.push(userSettingsRepository.loadUserSettings());
        await Promise.all(allPromises).then((response) => {
            this.processLoadedDataForPage(response[0], response[1], response[2], response[3], response[4], response[5], response[6], response[7], response[8]);
        });
    }
    async processLoadedDataForPage(sourceGroups, source, eventTypes, units, sourceChanges, tier, companyLoggerList, sourceList, settings) {
        this.annotateLogerStateChange = settings.preferences.annotateLoggerStateChange || 'true';
        this.source = source;
        this.sourceGroups = sourceGroups.getData();
        this.sourceGroups.push(SourceGroup.createNullSourceGroup([]));
        this.eventTypes = EventType.addUnits(eventTypes, units);
        this.sourceChanges = sourceChanges;
        CompanyLogger.addSources(companyLoggerList.getData(), sourceList.getData());
        if (this.source.logger)
            this.availableCompanyLoggers = companyLoggerList
                .getData()
                .filter((x) => x.companyLoggerId != this.source.logger.companyLoggerId);
        else
            this.availableCompanyLoggers = companyLoggerList.getData();
        if (this.source.hasLogger()) {
            this.availableCompanyLoggers = companyLoggerList
                .getData()
                .filter((x) => x.companyLoggerId != this.source.logger.companyLoggerId);
            let additionalPromises = [];
            let loadFrom = new Date();
            loadFrom.setDate(loadFrom.getDate() - 1); //load signal for 1 day
            let convertedDate = this.dateTimeManager.formatStartDateForReports(loadFrom).text;
            additionalPromises.push(companyLoggerRepository.loadLoggerRssi(this.source.logger.companyLoggerId, convertedDate));
            await Promise.all(additionalPromises).then((response) => {
                this.rssiData = response[0];
            });
        }
        else {
            this.availableCompanyLoggers = companyLoggerList.getData();
        }
        SourceChanges.sortByDate(this.sourceChanges);
        this.tier = tier;
        this.isLoading = false;
    }
    async loadSignal(from) {
        this.isLoadingSignal = true;
        let convertedDate = this.dateTimeManager.formatStartDateForReports(from).text;
        this.rssiData = await companyLoggerRepository.loadLoggerRssi(this.source.logger.companyLoggerId, convertedDate);
        this.isLoadingSignal = false;
    }
    async editingLogger() {
        if (this.isEditing == false) {
            this.quantities = await sourceRepository.getQuantities(this.source.id);
        }
        this.isEditing = !this.isEditing;
    }
    openChangeLogger(reassigning = false) {
        this.modalIsReassigning = reassigning;
        this.isChangeLoggerModalActive = true;
    }
    hasChanges() {
        return this.$refs.loggerInfoComponent.hasChanges;
    }
    deleteLogger() {
        this.$buefy.dialog.confirm({
            title: `${this.$t('component.logger.list.delete_logger')}`,
            message: this.$t('component.logger.list.delete_logger_note'),
            confirmText: `${this.$t('component.logger.remove_modal.confirm')}`,
            cancelText: `${this.$t('component.logger.remove_modal.deny')}`,
            type: 'is-primary',
            hasIcon: true,
            onConfirm: async () => {
                let result = await sourceRepository.deleteLogger(this.source.id);
                if (result) {
                    VueUtilities.openSuccessToast(this, this.$t('component.logger.remove_modal.success'));
                    this.$router
                        .push({
                        name: 'configuration_loggers',
                        params: {
                            lang: this.$route.params.lang,
                            departmentId: this.$route.params.departmentId
                        }
                    })
                        .catch((err) => err);
                }
                else {
                    VueUtilities.openErrorToast(this, this.$t('component.logger.remove_modal.failure'));
                }
            },
            onCancel: () => { }
        });
    }
    async createService(service) {
        this.isLoading = true;
        let result = await sourceRepository.setServiceForSource(this.source.id, service);
        if (result instanceof SourceService) {
            VueUtilities.openSuccessToast(this, this.$t('component.logger.service.modal.success'));
            this.source.setService(result);
            this.closeServiceModal();
        }
        else {
            VueUtilities.openErrorToast(this, this.$t('component.logger.service.modal.failure'));
        }
        this.isLoading = false;
    }
    async editService(serviceDto) {
        this.isLoading = true;
        let result = await sourceRepository.updateServiceForSource(this.source.id, this.source.activeService.id, serviceDto);
        if (result instanceof SourceService) {
            VueUtilities.openSuccessToast(this, this.$t('component.logger.service.edit_modal.success'));
            this.closeEditServiceModal();
            this.$nextTick(() => {
                this.checkIfServiceIsStillValid(result);
            });
        }
        else {
            VueUtilities.openErrorToast(this, this.$t('component.logger.service.edit_modal.failure'));
        }
        this.isLoading = false;
    }
    async readData(dto) {
        let res = await companyLoggerRepository.readLoggerData(this.source.logger.companyLoggerId, dto);
        if (res === true) {
            VueUtilities.openSuccessToast(this, this.$t('admin.component.loggers.detail.info.readData.success'));
            this.closeReadDataModal();
        }
        else {
            VueUtilities.openErrorToast(this, this.$t('admin.component.loggers.detail.info.readData.failure'));
        }
    }
    /**
     * Check if service time is not less than current tomi (eg. window opened for long time).
     * If service is ended, reload source and data.
     */
    checkIfServiceIsStillValid(service) {
        if (service.endTime * 1000 < new Date().getTime()) {
            this.loadData();
        }
        else {
            this.source.setService(service);
        }
    }
    closeChangeLoggerModal(data) {
        this.isChangeLoggerModalActive = false;
    }
    closeUnsavedChangesModal() {
        this.isUnsavedChangesModalActive = false;
    }
    saveUnsavedChanges() {
        this.closeUnsavedChangesModal();
        this.$refs.loggerInfoComponent.validate();
    }
    openServiceModal() {
        this.isServiceModalActive = true;
    }
    closeServiceModal() {
        this.isServiceModalActive = false;
    }
    closeEditServiceModal() {
        this.isEditServiceModalActive = false;
    }
    openDiscardLoggerModal() {
        this.isDiscardLoggerModal = true;
    }
    closeDiscardLoggerModal() {
        this.isDiscardLoggerModal = false;
    }
    closeReadDataModal() {
        this.isReadDataModalActive = false;
    }
    openEditServiceModal() {
        this.checkIfServiceIsStillValid(this.source.activeService);
        this.isEditServiceModalActive = true;
    }
    openReadDataModal() {
        this.isReadDataModalActive = true;
    }
};
LoggerDetail = __decorate([
    Component({
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (vm.$userCan(CustomerPermissions.SOURCEGROUPS_READ) && vm.$userCan(CustomerPermissions.SOURCES_READ)) {
                    next();
                }
                else {
                    next({ name: 'missingPermissions' });
                }
            });
        },
        beforeRouteLeave(to, from, next) {
            if (this.hasChanges() && to.query.confirmed != 'true') {
                this.routeToNavigate = to;
                this.isUnsavedChangesModalActive = true;
            }
            else {
                next();
            }
        },
        components: {
            LoggerInfo,
            UnsavedChangesDialog,
            LoggerChanges,
            SetServiceModal,
            EditServiceModal,
            LoggerRssiChart,
            DiscardLoggerModal,
            ChangeLoggerModal,
            ReadDataFromLoggerModal
        }
    })
], LoggerDetail);
export default LoggerDetail;
